import React from "react";
import { abbreviateNumber } from "pages/dealScreener/Email/constants";
import numeral from "numeral";
import styled from "styled-components";

const Container = styled.div`
    display: table-cell;
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 12px;
`;

const TopBoxCapRateBoldText = styled.div`
    font-weight: 600;
    line-height: 16px;
    color: #FFFFFF;
`;

const TopBoxCapRateSubText = styled.div`
    font-size: 8px;
    font-weight: 400;
    line-height: 10px;
    color: #FFFFFF;
`;

const BottomBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #DADCE0;
    border-bottom: 1px solid #DADCE0;
    border-left: 1px solid #DADCE0;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    color: #5F6368;
    padding: 0.75em 0;
    word-spacing: -4px;
`;

const ValuationSensitivityToCapRateBox = ({ capRate = 0, valuation = 0, color }) => {
  const TopBox = styled.div`
    border: 1px solid #DADCE0;
    background-color: #${color};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0.75em 0;
    font-size: 12px;
    `;

  return (
    <Container>
      <Wrapper>
        <TopBox>
          <TopBoxCapRateBoldText>{numeral(capRate).format("0.00%")}</TopBoxCapRateBoldText>
          <TopBoxCapRateSubText>cap rate</TopBoxCapRateSubText>
        </TopBox>
        <BottomBox>
          $
          {abbreviateNumber(valuation)}
        </BottomBox>
      </Wrapper>
    </Container>
  );
};

export default ValuationSensitivityToCapRateBox;
